import React from 'react';
import * as Styled from './styles';

export const FormGroupWrapper = ({ children }) => <Styled.Wrapper>{children}</Styled.Wrapper>;
